export const HOUSE_ROT = {
  isHidden: true,
  nickname: 'PRODUCTS.HOUSE_ROT.nickname',
  icon:'house-rot'
};
